import React from 'react';

export interface FocusActionProps {
  children: React.ReactNode;
  accent?: boolean;
  small?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

export function FocusAction({
  children,
  accent = false,
  small = false,
  onClick,
  disabled = false,
}: FocusActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: small ? '5px 11px' : '8px 14px',
        fontSize: small ? 12.5 : 13.5,
        fontFamily: 'var(--font-ui)',
        fontWeight: 500,
        color: accent ? 'var(--on-accent)' : 'var(--ink)',
        background: accent ? 'var(--accent)' : 'var(--paper)',
        border: `1px solid ${accent ? 'var(--accent)' : 'var(--rule)'}`,
        borderRadius: 7,
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        transition: 'transform 120ms ease, filter 120ms ease',
      }}
      onMouseEnter={(e) => {
        if (!disabled) e.currentTarget.style.transform = 'translateY(-1px)';
        if (!disabled && accent) e.currentTarget.style.filter = 'brightness(1.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.filter = 'none';
      }}
    >
      {children}
    </button>
  );
}
